// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBFDxnbJHFXnbJAkIjDQJOoZnQTCOGh9Ks",
  authDomain: "nqobimphilo-creations.firebaseapp.com",
  projectId: "nqobimphilo-creations",
  storageBucket: "nqobimphilo-creations.appspot.com",
  messagingSenderId: "1052033266775",
  appId: "1:1052033266775:web:c9f83c0c1c6a1e5e5a4a4a",
  measurementId: "G-XXXXXXXX" // Replace with your actual measurement ID if needed
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { app, db };